<template>
  <div>
    <table style="width: 100%; ">
      <thead>
        <tr>
          <th>#</th>
          <th>{{ $t("task.name") }}</th>
          <th>{{ $t("task.description") }}</th>
          <th>{{ $t("task.assignee") }}</th>
          <th>{{ $t("task.status.text") }}</th>
          <th>{{ $t("organization.text") }}</th>
        </tr>
        <tr>
          <th><input :placeholder="$t('task.no-in-short')" class="form-control" v-model="noFilter" type="text" /></th>
          <th><input :placeholder="$t('task.name')" class="form-control" v-model="nameFilter" type="text" /></th>
          <th><input :placeholder="$t('task.description')" class="form-control" v-model="descriptionFilter" type="text" /></th>
          <th>
            <filter-select
              v-if="activeTab != 'account' && scope != 'ACCOUNT'"
              id="accountFilter"
              ref="accountFilter"
              :placeholder="$t('common.name')"
              :multiple="false"
              @filter="accountSearch"
              :selected="account"
              @changed="accountSelect"
            />
          </th>
          <th>
            <select v-model="statusFilter" class="form-control">
              <option :value="null">{{ $t("common.clear-selection") }}</option>
              <option value="UNWORKED">{{ $t("task.status.unworked") }}</option>
              <option value="NOT_FIT">{{ $t("task.status.not-fit") }}</option>
              <option value="TODO">{{ $t("task.status.todo") }}</option>
              <option value="IN_PROGRESS">{{ $t("task.status.in-progress") }}</option>
              <option value="APPROVAL">{{ $t("task.status.approval") }}</option>
              <option value="DONE">{{ $t("task.status.done") }}</option>
            </select>
          </th>
          <th>
            <filter-select
              v-if="activeTab == 'account' && scope == 'ACCOUNT'"
              id="organizationSelect"
              ref="organizationSelect"
              :placeholder="$t('organization.name')"
              :multiple="false"
              @filter="organizationSearch"
              :selected="organization"
              @changed="organizationSelect"
            />
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="task in tasks" :key="'task-list-' + task._id" @click="openDetail(task)" class="hand">
          <td class="gray-text">#{{ task.no }}</td>

          <td style="min-width:300px;">
            <div class="d-flex" style="gap: 1rem;">
              {{ task.name | translate | summary(50) }}
            </div>
          </td>

          <td class="gray-text">{{ task.description | translate | summary(150) }}</td>
          <td>
            <div class="d-flex align-items-center" style="gap: 0.62rem;">
              <task-avatar :account="task.assignee" />
              <span v-if="task.assignee">{{ task.assignee.name }}</span>
              <span v-else class="userName">{{ $t("task.unassigned") }}</span>
            </div>
          </td>
          <td style="min-width: 205px;">
            <div class="d-flex align-items-center">
              <task-status :status="task.status" />
            </div>
          </td>
          <td style="min-width: 205px;">
            <div class="d-flex align-items-center">
              <!-- <letter-avatar :name="task.organization.name" :showName="true" size="xxs" :image="task.organization.logo" variant="secondary" /> -->
              {{ task.organization.name }}
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <content-loading v-if="isMyTasksLoading" />
    <content-loading v-if="isOrganizationTasksLoading" />
  </div>
</template>

<script>
import OrganizationMemberSelect from "@cc/organization-member-select";
export default {
  props: ["name", "no", "description", "account", "status", "organization", "scope", "activeTab", "archived"],
  components: { OrganizationMemberSelect },
  data() {
    return {
      nameFilter: this.name,
      noFilter: this.no,
      descriptionFilter: this.description,
      accountFilter: this.account,
      statusFilter: this.status,
      organizationFilter: this.organization,
    };
  },
  watch: {
    nameFilter() {
      this.debounce(() => this.$emit("nameFilter", this.nameFilter));
    },
    noFilter() {
      this.debounce(() => this.$emit("noFilter", this.noFilter));
    },
    descriptionFilter() {
      this.debounce(() => this.$emit("descriptionFilter", this.descriptionFilter));
    },
    statusFilter() {
      this.$emit("statusFilter", this.statusFilter);
    },
  },
  mounted() {},
  computed: {
    isOrganizationTasksLoading() {
      return this.$store.getters["task/isOrganizationTasksLoading"];
    },
    isMyTasksLoading() {
      return this.$store.getters["task/isMyTasksLoading"];
    },
    myTasksPagination() {
      return this.$store.getters["task/myTasksPagination"];
    },
    organizationTasksPagination() {
      return this.$store.getters["task/organizationTasksPagination"];
    },
    tasks() {
      if (this.activeTab == "account") {
        return this.myTasksPagination?.docs ?? [];
      } else {
        return this.organizationTasksPagination?.docs ?? [];
      }
    },
  },
  methods: {
    openDetail(task) {
      this.$store.commit("task/showTaskDetailModal", true);
      this.$store.dispatch("task/fetchDetail", task._id);
    },

    async accountSearch(value, callback) {
      const response = await this.$store.dispatch("organizationMember/paginateWith", {
        pagination: { query: { accessable: { value: true, isObject: true } } },
        organizationId: this.currentOrganization?._id,
      });
      callback(response.data?.docs ?? []);
    },

    accountSelect(acc) {
      if (!acc) {
        this.$emit("accountFilter", acc);
      } else {
        this.accountFilter = { _id: acc.accountId, name: acc.name };
        if (acc?._id != this.account?._id) {
          this.$emit("accountFilter", { ...this.accountFilter });
        }
      }
    },
    onStatusSelect(status) {
      if (!status) {
        this.status = null;
        this.$emit("statusFilter", null);
        return;
      }
      this.status = status;

      this.$emit("statusFilter", this.status);
    },
    async organizationSearch(value, callback) {
      const response = await this.$store.dispatch(`organization/paginate`, {
        options: { limit: 200 },
        query: { name: { value } },
      });
      callback(response.data?.docs ?? []);
    },

    organizationSelect(org) {
      this.organizationFilter = org;
      if (org?._id != this.organization?._id) {
        this.$emit("organizationFilter", { ...this.organizationFilter });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./tasks";
</style>

<style>
.multiselect--active {
  z-index: 9999999999 !important;
  position: static !important;
}
.multiselect__content-wrapper {
  max-width: 300px !important;
}
</style>
